<script>
    import { Line } from 'vue-chartjs'

    export default {
        extends: Line,
        data: () => ({
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true
                },
                scales: {
                    yAxes: [{
                        display: true,
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: 100
                        }
                    }]
                },
            }
        }),
        props: {
            chartData: {
                type: Object,
                default: null
            }
        },
        computed: {
            chartDataFormatted() {
                return {
                    labels: this.formatDates(this.chartData.labels),
                    datasets: [
                        {
                            label: 'Back pressure',
                            borderColor: '#41b883',
                            data: this.chartData.back_pressure_rates
                        },
                        {
                            label: 'Weight',
                            borderColor: '#35495e',
                            data: this.chartData.weight_rates
                        },
                        {
                            label: 'Leakage',
                            borderColor: '#35495e',
                            data: this.chartData.leakage_rates
                        }
                    ]
                }
            }
        },
        mounted () {
            this.renderChart(this.chartDataFormatted, this.options)
        },
        methods:{
            //Date array formatten van Y-M-D naar D/M/Y
            formatDates(dates){
                let returnDate = []
                for(let key in dates){
                    returnDate.push(this.moment(dates[key]).format('D/M/Y'))
                }
                return returnDate
            }
        }
    }
</script>
